let down = [
  {
    path: '/down',
    component: () => import(/* webpackChunkName: "down" */ '@/pages/down/index.vue'),
    meta: {
      title: '信用飞',
    },
  }
];

export default down;